import React, { useMemo } from 'react';
import { GridTileType } from './InfiniteMediaLibrary';

import {
  GridLayout,
  GridLayoutTile,
} from '@vimily/bonjoro-ui-components-v2/GridLayout';

import { MediaLibraryAsset } from './InfiniteMediaLibraryItem';
import InfiniteMediaLibraryItemContainer, {
  InfiniteMediaLibraryItemContainerProps,
} from './InfiniteMediaLibraryItemContainer';

export interface InfiniteMediaLibraryItemsProps {
  gridTileType?: GridTileType;
  libraryItems?: MediaLibraryAsset[];
  onTagUpdated?: (resourceId?: string) => void;
  selectedIds?: string[];
  addSelectedId?: (id: string) => void;
  removeSelectedId?: (id: string) => void;
  isItemSelectDisabled?: (id: string) => boolean;
}

export default function InfiniteMediaLibraryItems({
  gridTileType,
  libraryItems = [],
  onTagUpdated,
  addSelectedId,
  selectedIds,
  removeSelectedId,
  isItemSelectDisabled: isSelectDisabled,
}: InfiniteMediaLibraryItemsProps) {
  const selectedIdsMap = useMemo(
    () =>
      selectedIds?.reduce<Record<string, boolean>>((map, uuid) => {
        map[uuid] = true;

        return map;
      }, {}) ?? {},
    [selectedIds]
  );

  const sharedItemProps: Omit<InfiniteMediaLibraryItemContainerProps, 'asset'> =
    {
      gridTileType,
      onTagUpdated,
      addSelectedId,
      removeSelectedId,
    };

  if (gridTileType === GridTileType.Dynamic) {
    return (
      <GridLayout className='w-full grid-cols-[repeat(auto-fill,_minmax(300px,1fr))]'>
        {libraryItems.map((item, index) => (
          <GridLayoutTile
            key={`${index}`}
            className='break-inside-avoid'
          >
            <InfiniteMediaLibraryItemContainer
              {...sharedItemProps}
              asset={item}
              selected={selectedIdsMap[item.uuid]}
              selectDisabled={isSelectDisabled?.(item.uuid) ?? false}
            />
          </GridLayoutTile>
        ))}
      </GridLayout>
    );
  }

  return (
    <>
      {libraryItems.map((item) => (
        <InfiniteMediaLibraryItemContainer
          {...sharedItemProps}
          key={item.uuid}
          asset={item}
          selected={selectedIdsMap[item.uuid]}
          selectDisabled={isSelectDisabled?.(item.uuid) ?? false}
        />
      ))}
    </>
  );
}
